import React from 'react';

import './Card.scss';

interface CardProps {
  children: React.ReactNode;
}

const Card = ({ children }: CardProps): React.ReactElement => {
  return <div className={`card-container`}>{children}</div>;
};

export default Card;
